<template>
  <div class="fb-btn"
  >
    <a target="_blank" href="https://m.me/cloudw2p.tw/">
      <i class="fa-brands fa-facebook-messenger"></i>
    </a>
  </div>
</template>

<script>
export default {
  name: 'scrollBtn',
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.fb-btn {
  position: fixed;
  cursor: pointer;
  right: 30px;
  color: #ffffff;
  background-color: #5c87a6;
  z-index: 4;
  width: 45px;
  text-align: center;
  height: 45px;
  opacity: 1;
  visibility: visible;
  bottom: 30px;
  border-radius: 50%;
  font-size: 22px;
  // transition: 0.6s;
  overflow: hidden;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);

  i {
    color: #ffffff;
    position: absolute;
    right: 0;
    left: 0;
    top: 48%;
    transform: translateY(-45%);
    text-align: center;
    font-size: 1.2rem;
    margin-left: auto;
    margin-right: auto;
  }
  &:hover {
    background-color: #5c87a6;
    color: #ffffff;
    transition: 0.6s;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    transform: translateY(-5px);
  }
}
@media (max-width: 641px) {
  .fb-btn {
    right: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fbBtn.vue